import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";


type Entity = models.PaquetePPCobranzaDto;
const guiaColumnasFijas: kea.Grid2Column<Entity>[] = [
    {
        title: "Folio",
        cell: x => ({ data: x.Folio }),
    }, {
        title: "Total",
        cell: x => ({ data: x.ImporteTotal, view: kea.formatCurrency })
    }, {
        title: "Fecha creación",
        cell: x => ({ data: kea.toDate(x.FechaCreacion) })
    }, {
        title: "Cli. orig.",
        cell: x => ({ data: x.NombreClienteOrigen })
    }, {
        title: "Cli. dest.",
        cell: x => ({ data: x.NombreClienteDestino })
    }
]
export interface Deps {
    onVer: (x: Entity) => void;
}
export function columnas(deps: Deps) {
    const ret: kea.Grid2Column<Entity>[] = [
        kea.columnaBotones([
            {
                iconClass: fa("eye"),
                onClick: deps.onVer,
                tooltip: "Ver detalle"
            }
        ]),
        ...guiaColumnasFijas
    ];

    return ret;
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/cobranza/contrarecibos/modales/generarcontrarecibospp/paquetespp/columns.tsx